import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, branch, renderComponent, withState, lifecycle, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import History from '@material-ui/icons/History';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import avatar from '../assets/avatar.jpg';

import {
  learnerVersionsRequest,
  printReportRequest,
  resetLearnerVersion,
} from '../redux/reducers/savedVersions';
import { selectUserVersion } from '../redux/reducers/userProgramsFull';
import * as moment from 'moment';

import Spinner from './Spinner';
import { commonStyles } from '../styles/styles';
import iconPrint from '../assets/icon_print.svg';
import { convertTime } from '../utils';
import IframePopup from './Popups/IframePopup';
import {getUsersForProgram, selectedProgram, getPrograms, getVersionsForThinktool, selectedUser} from '../redux/selectors'

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBadge} from "mdbreact";
import ModalPopup from './Popups/ModalPopup';
import CoachRatingPopupView from './Popups/CoachRatingPopupView';



const CoachVersionsList = ({
  classes,
  savedVersions,
  handlePrint,
  handleClickVersion,
  handlePopupToggle,
  isShowPopup,
  versions,
  handleShowComment,
  showComment,
  comment,
  handleHideComment,
  showCommentCoach,
  handleShowCommentCoach
}) => {
  console.log('VERSIONS', versions)

  const getButtonAction = (action, item) => {
    var btn = null
    switch (action) {
      case 'draft':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="warning"  onClick={() => handleClickVersion( item.version_id)}>RESTORE</MDBBtn>
        break;
      case 'reviewed':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="success"  onClick={() => handleClickVersion(item.version_id)}>VIEW</MDBBtn>
        break;
      case 'pending':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="danger-dark" onClick={() => handleClickVersion(item.version_id)}>REVIEW</MDBBtn>
        break;
      case 'completed':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="info">SHARE WITH COACH</MDBBtn>
        break;
      default:
        btn = <MDBBtn>Test</MDBBtn>
        break;
    }
      // if(content.type!=='Assignments'){
      //   return false;
      // }else{
        return btn;
      //}
     
    };

    const getStatus = action => {
      var btn = null
      switch (action) {
        case 'draft':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="warning-light">DRAFT</MDBBadge>
          break;
        case 'reviewed':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="success-light">REVIEWED</MDBBadge>
          break;
        case 'pending':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="danger-light">PENDING</MDBBadge>
          break;
        case 'completed':
          btn = <MDBBadge className="noShadow" style={{padding: 7, borderRadius:'0.25rem'}} color="info-light">COMPLETED</MDBBadge>
          break;
        default:
          btn = <MDBBadge>Test</MDBBadge>
          break;
      }
        // if(content.type!=='Assignments'){
        //   return false;
        // }else{
          return btn;
        //}
       
      };
  if (versions) {
    const renderVersions = (item) => {
      
      return (
        <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
          <MDBCol className="table-col pl-2 leftAlign"> <p> {item.name}</p></MDBCol>
          <MDBCol className="table-col"><div className="xs-copy-ptsans"><p>
            {item.user_rating ? <MDBBadge style={{position:'static',marginRight: 5,cursor:'pointer'}} className="badge-lg-pill-round danger-color-border noShadow"  color="danger-color" onClick={()=>handleShowComment(item.user_comment)}>{item.user_rating}</MDBBadge> : 'N/A'}</p></div> 
           </MDBCol>
            <MDBCol className="table-col"> <div className="xs-copy-ptsans"><p>


            {item.coach_rating ? <MDBBadge style={{position:'static',marginRight: 5,cursor:'pointer'}} className="badge-lg-pill-round noShadow"  color="badge-success-light"  onClick={()=>handleShowCommentCoach(item)}>{item.quality_rating}</MDBBadge> :'N/A'}

            </p></div> </MDBCol>
          <MDBCol className="table-col"><p><MDBIcon className="pr-2" far icon="calendar" />{moment(item.updated_at).format('YYYY/MM/DD')}</p></MDBCol>
          {/* <MDBCol className="table-col"> 
            <p>
            <div className="mailBadge m-0" onClick={()=>this.props.showMessageCenter(true)}>
              <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
              <MDBBadge style={{left: '50%'}} className="badge-white badge-sm-pill-round">{item.numberOfUnreadMessages}</MDBBadge>
            </div>
            </p>
          </MDBCol> */}
          <MDBCol className="table-col"><p>{getStatus(item.status)}</p></MDBCol>
          <MDBCol className="col-2 table-col pr-2 no-border"><p>{getButtonAction(item.status, item)}</p></MDBCol>
          </MDBRow>

      );
      };
      const renderVersionsMedium = (item) => {
      
        return (
         <MDBCard>
            <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
              <MDBCol className="table-col pl-2">

                <div className="pt-2 pb-2">
                  <b> {item.name}</b>
                </div>
                <div  style={{display:'inline-block'}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.updated_at).format('YYYY/MM/DD')}
                </div>
                <div style={{display:'inline-block', paddingLeft:10}}>
                  {getStatus(item.status)}
                </div>
              </MDBCol>
              <MDBCol className="table-col pl-2 no-border">
                <div style={{width:'50%', textAlign:'center', float:'left'}}>
                 <div className="xs-copy-ptsans">
                 {item.coach_rating ? <MDBBadge style={{position:'static',marginRight: 5,cursor:'pointer'}} className="badge-lg-pill-round danger-color-border "  color="danger-color"  onClick={()=>handleShowCommentCoach(item)}>{item.quality_rating}</MDBBadge> : 'N/A'}
                  </div>
                  <p className="xs-copy">Coach Rating</p>
                </div>
                <div style={{width:'50%', textAlign:'center', float:'right'}}>
                  <div className="xs-copy-ptsans">

                  {item.user_rating ? <MDBBadge style={{position:'static',marginRight: 5,cursor:'pointer'}} className="badge-lg-pill-round noShadow "  color="badge-success-light"  onClick={()=>handleShowComment(item.user_comment)}>{item.user_rating}</MDBBadge> : 'N/A'}

                  </div>
                  <p className="xs-copy">User Rating</p>
                </div>
                <div style={{clear: 'both'}}></div>
                {/* <div style={{width:'50%', textAlign:'center', float:'left'}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{left: '50%'}} className="badge-white badge-sm-pill-round">{item.unreadMsgs}</MDBBadge>
                  </div>
                </div> */}
                <div style={{width:'50%', textAlign:'center', float:'left'}}>
                  {getButtonAction(item.status, item)}
                </div>
              </MDBCol>
            </MDBRow>
        </MDBCard>
        );
        };
      const renderVersionsSmall = (item) => {
      
        return (
          <MDBCard className="noShadowMobile">
            <MDBRow className="w-100 small-copy p-0" style={{width:'100%', margin: '0 auto'}}>
              <div style={{margin: '0px auto',width: '100%', backgroundColor: 'rgb(235, 235, 235)', padding:10}}>
            
                <div className="pt-2 pb-2">
                  <b>{item.name}</b>
                </div>
                <div  style={{display:'inline-block'}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.updated_at).format('YYYY/MM/DD')}
                </div>
                <div style={{display:'inline-block', paddingLeft:10}}>
                  {getStatus(item.status)}
                </div>
              </div>
              <div style={{margin: '0px auto',width: '100%', padding:10}}>
                <div style={{width:'35%', float:'left', textAlign: 'center'}}>
                 <div className="xs-copy-ptsans">
                 {item.coach_rating ?<MDBBadge style={{position:'static',marginRight: 5,cursor:'pointer'}} className="badge-lg-pill-round danger-color-border "  color="danger-color"  onClick={()=>handleShowCommentCoach(item)}>{item.quality_rating}</MDBBadge> : 'N/A' }
                  </div>
                  <p className="xs-copy">Coach Rating</p>
                </div>
                <div style={{width:'35%', float:'left', textAlign: 'center'}}>
                 <div className="xs-copy-ptsans">

                 {item.user_rating ?<MDBBadge style={{position:'static',marginRight: 5,cursor:'pointer'}} className="badge-lg-pill-round noShadow "  color="badge-success-light"  onClick={()=>handleShowComment(item.user_comment)}>{item.user_rating}</MDBBadge> : 'N/A'}

                  </div>
                  <p className="xs-copy">User Rating</p>
                </div>
                {/* <div style={{width:'30%', float:'left', textAlign: 'center', marginTop:10}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{left: '50%'}} className="badge-white badge-sm-pill-round">{item.unreadMsgs}</MDBBadge>
                  </div>
                </div> */}
                <div style={{clear: 'both'}}></div>
                <div>
                  {getButtonAction(item.status, item)}
                </div>
              </div>
            </MDBRow>
        </MDBCard>
        );
        };
    return (
     
      <div>
    <MDBCard  className="z-depth-2 rounded-0 d-none d-lg-block yellow-card" style={{height:"100%"}}>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
      INSTANCES
    </div>
        
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
      <div style={{backgroundColor:'#ffffff'}}>
      <MDBRow className="small-copy w-100 pt-2 pb-2" style={{margin: '0 auto', backgroundColor:'#EBEBEB'}}>
          <MDBCol className="center">Instance</MDBCol>
          <MDBCol className="center">Student Rating</MDBCol>
          <MDBCol className="center">Coach rating</MDBCol>
          <MDBCol className="center">Last Accessed</MDBCol>
          {/* <MDBCol className="center">Messages</MDBCol> */}
          <MDBCol className="center">Status</MDBCol>
          <MDBCol className="col-2 center">Actions</MDBCol>
      </MDBRow>
      <div className="contentScrollList">
      {versions.map((item, idx) => (
      renderVersions(item)
      ))}
      </div>
    </div>

</MDBCard>
<MDBCard  className="z-depth-2 rounded-0 d-none d-md-block d-lg-none yellow-card" style={{height:"100%"}}>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
        INSTANCES
    </div>
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
    <div className="contentScrollList" style={{backgroundColor:'#ffffff'}}>
      {versions.map((item, idx) => (
      renderVersionsMedium(item)
      ))}
    </div>

</MDBCard>

<MDBCard  className="z-depth-2 rounded-0  d-md-none yellow-card" style={{height:"100%"}}>
  <div className='gothamBlack text-dark text-left pt-3 pl-3'>
        INSTANCES
        </div>
        
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
    <div className="contentScrollList" style={{backgroundColor:'#ffffff'}}>
      {versions.map((item, idx) => (
      renderVersionsSmall(item)
      ))}
      </div>
      

</MDBCard>
        {/* {savedVersions.learnerVersions.reverse().map((item, idx) => (
          <div className={classes.versionItem} key={idx.toString()}>
            <div className={classes.itemLeft}>
              <p className={classes.versionName}>{item.name}</p>
              <History className={classes.itemIcon} />
              <span className={classes.versionDate}>{convertTime(item.updated_at.date)}</span>
            </div>
            {item.progressPercentage && (
              <div className={classes.itemPercentage}>{`${item.progressPercentage}%`}</div>
            )}
            <div className={classes.itemRight}>
              <div className={classes.itemLink}>
                
                <img src={iconPrint} alt="print" onClick={() => handlePrint(item.versionId)} />
               
              </div>
              <Button
                className={`${classes.defaultButton} ${classes.buttonVersions}`}
                variant="raised"
                onClick={() => handleClickVersion(item.path, item.versionId)}
              >
                RESTORE
              </Button>
            </div>
          </div>
        ))} */}
        {isShowPopup &&
          savedVersions.versionsPdf && (
            <IframePopup
              handlePopupToggle={handlePopupToggle}
              pathToIframeFile={savedVersions.versionsPdf.path}
              selectedContentItem={{ type: 'Document' }}
              contentIframe={false}
            />
          )}
         {showComment &&
         comment && (
          <ModalPopup type='success' color='success' title='Comment' body={comment} handleClose={handleHideComment}/>
          )}
          {showCommentCoach &&
         comment && (
          <CoachRatingPopupView  comment={comment.coach_comment} coach_name={comment.coach_name} quality={comment.quality_rating} completion={comment.coach_rating} handleClose={handleHideComment}/>
          )}
      </div>
    );
  }
  return <Typography className={classes.text}>{savedVersions.error}</Typography>;
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  versions: getVersionsForThinktool(state),
  userProgramsFull: state.userProgramsFullReducer,
  savedVersions: state.savedVersionsReducer,
});

const mapDispatchToProps = dispatch => ({
  printReportRequest: versionId => dispatch(printReportRequest(versionId)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  resetLearnerVersion: () => dispatch(resetLearnerVersion()),
});

export default compose(
   withRouter,
  withState('isShowPopup', 'togglePopup', false),
  withState('startTime', 'setStartTime', null),
  withState('stopTime', 'setStopTime', null),
  withState('showComment', 'setShowComment', false),
  withState('comment', 'setComment', null),
  withState('showCommentCoach', 'setShowCommentCoach', false),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handlePrint: props => value => {
      props.selectUserVersion(value);
      props.printReportRequest(value);
      props.togglePopup(true);
    },
    handlePopupToggle: props => () => {
      props.togglePopup(false);
    },
    handleShowComment: props => (comment) => {
      props.setComment(comment);
      props.setShowComment(true);
    },
    handleHideComment: props => (item) => {
      props.setShowComment(false);

      props.setShowCommentCoach(false);
    },
    handleShowCommentCoach: props => (comment) => {
    
      props.setComment(comment);
      props.setShowCommentCoach(true);
    },
    handleClickVersion: props => (versionId) => {
      const {
        selectUserVersion,
        userProgramsFull: { selectedProjectId,selectedRollout, selectedThinkToolId, selectedVersionId, selectedUserId },
      } = props;
      selectUserVersion(versionId);
      props.history.push(
        `/users/${selectedProjectId}/${selectedRollout}/${selectedUserId}/${selectedThinkToolId}/${versionId}`+ props.history.location.search,
      );
    },
  }),
  lifecycle({
    componentWillMount() {
      console.log('USERS1', this.props)
    },
  }),
  withStyles(styles),
)(CoachVersionsList);

CoachVersionsList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  savedVersions: PropTypes.instanceOf(Object),
  handlePrint: PropTypes.func,
  handleClickVersion: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/Components/CoachVersionsList.jsx